<template>
  <div class="mailBtnCancel" v-if="$store.state.isShowRBot">
    <span class="btn-back" v-show="oType==='userSave'&&index==3" 
      @click.stop="handleBack()">上一步</span>

    <span class="btn-cancel" v-show="oType !== ''" v-text="btnText" 
      @click.stop="handleCancel()"></span>

    <span class="explain">极酷物联提供技术支持</span>
  </div>
</template>

<script>
import { showToast } from '../../../../static/mailBox/js/request';
export default {
  name: 'btnCancel',
  
  data() {
    return {
      btnText: '取消操作',
      screenHeight: window.innerHeight,
      oType: this.$store.state.mail_oType,
      index: this.$store.state.mail_index
    }
  },

  created() {
    console.log('子组件的isShowRBot：',this.$store.state.isShowRBot)
    if ((this.oType==='userFastSave'&&this.index === 3)||(this.oType==='userSave'&&this.index === 4)) {
      this.btnText = '投递完成'
    }
  },

  mounted () {
    console.log('this', this)
    let vm = this
    window.onresize = () => {
      return (() => {
        vm.screenHeight = window.innerHeight
      })()
    }
  },

  watch: {
    'screenHeight' (newVal, oldVal) {
      // 1007， 543
      console.log('oldVal:', oldVal, 'newVal:', newVal)
      // showToast(`${oldVal},${newVal}`)
      if (oldVal > newVal) {
        this.$store.state.isShowRBot = false;
        console.log('不显示', '')
        // showToast('不显示')
      } else {
        // showToast('显示')
        // console.log('显示', '')
        this.$store.state.isShowRBot = true;
      }
    }
  },

  methods: {
    // 
    handleBack () {
      let vm = this
      vm.$router.go(-1)
    },
     
    //
    handleCancel () {
      let vm = this
      vm.$router.push({path: '/mailBox'})
      vm.$store.commit('mail_index', 1)
      vm.$store.commit('mail_type', '')
      vm.$store.commit('mail_oType', '')
      vm.$store.commit('mail_time', '')
      vm.$store.commit('mail_senderId', '')
      vm.$store.commit('mail_sendWay', '')
      vm.$store.commit('mail_deliver', {})

      // vm.$store.state.mail_index = 1
      // vm.$store.state.mail_type = ''
      // vm.$store.state.mail_oType = ''
      // vm.$store.state.mail_time = ''
      // vm.$store.state.mail_senderId = ''
      // vm.$store.state.mail_sendWay = ''
      // vm.$store.state.mail_deliver = {}
    },
  },
}
</script>
<style lang="less" scoped>
.mailBtnCancel {
  // position: absolute;
  // right: 0.5rem;
  // bottom: 1rem;
  // z-index: 2;
  // width: 500px;
  // height: 10px;
  .btn-cancel {
    display: block;
    width: 2.04rem;
    height: 0.88rem;
    line-height: 0.88rem;
    font-size: 0.34rem;
    border-radius: 0.1rem;
    text-align: center;
    color: #ffffff;
    background: linear-gradient(to top,#0669be, #4babfe);
    // position: absolute;
    // right: 0.5rem;
    // bottom: 1rem;
    // z-index: 2;
  }
  .btn-back {
      display: block;
      width: 2.04rem;
      height: 0.88rem;
      line-height: 0.88rem;
      font-size: 0.34rem;
      border-radius: 0.1rem;
      text-align: center;
      color: #ffffff;
      background: linear-gradient(to top, #0669be, #4babfe);
      position: absolute;
      right: 3rem;
      bottom: 1rem;
      z-index: 2;
    }
}
</style>





// WEBPACK FOOTER //
// src/components/mailBox/common/btnCancel.vue